"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITOP_SERVICE_STATUS = void 0;
exports.ITOP_SERVICE_STATUS = {
    IMPLEMENTATION: 'implementation',
    OBSOLETE: 'obsolete',
    PRODUCTION: 'production',
};
